/**
 * Длительность видеофайла в секундах по метаданным контейнера, без чтения
 * самого потока: браузер тянет из object URL только заголовок.
 *
 * Зачем: Cloudflare резервирует минуты хранения под незавершённую загрузку
 * по заявленному maxDurationSeconds. Пока длина неизвестна, бэкенд заявляет
 * глобальный потолок (часы), и несколько параллельных загрузок исчерпывают
 * план на 1000 минут ещё до первого байта (413 Storage capacity exceeded).
 *
 * Возвращает null, если браузер не смог разобрать файл (экзотический
 * контейнер, битые метаданные) или не уложился в таймаут: загрузка тогда
 * идёт с потолком, как раньше, а не отказывает.
 */
const READ_TIMEOUT_MS = 8000;

export const readVideoFileDuration = (file: File): Promise<number | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;

    let settled = false;
    const finish = (value: number | null) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      video.removeAttribute("src");
      video.load();
      URL.revokeObjectURL(url);
      resolve(value);
    };

    const timer = setTimeout(() => finish(null), READ_TIMEOUT_MS);

    video.onloadedmetadata = () => {
      const { duration } = video;
      finish(Number.isFinite(duration) && duration > 0 ? duration : null);
    };
    video.onerror = () => finish(null);
    video.src = url;
  });
